import { lazyNamed } from 'src/utils/lazyNamed.ts';

const AdsConfigV2 = {
  ConfigsList: lazyNamed(() => import('./containers/ConfigsList/index.tsx'), 'ConfigsList'),
  BlocksList: lazyNamed(() => import('./containers/BlocksList/index.tsx'), 'BlocksList'),
  Layout: lazyNamed(() => import('./components/Layout.tsx'), 'Layout'),
};

export default AdsConfigV2;
